// extracted by mini-css-extract-plugin
module.exports = {"main":"user-feed_main__1BRCv","link":"user-feed_link__1PUY7","scroll":"user-feed_scroll__3yU3t","loader":"user-feed_loader__2ngrI"};